export function instanceOfCodeValidationResult(
    data: any
): data is CodeValidationResult {
    return "testCaseResults" in data;
}

export type ValidationResult =
    | CodeValidationResult
    | InternalValidationError
    | CompilationError
    | UnknownError;

export interface TestCaseResult {
    passed: boolean;
    name: string;
    expectedValue: string;
    actualValue: string;
    errors: string[];
}

export interface CodeValidationResult {
    testCaseResults: TestCaseResult[];
}

export function instanceOfCompilationError(
    data: any
): data is CompilationError {
    return "errors" in data;
}

export interface CompilationError {
    errors: string[];
}

export function instanceOfInternalValidatorError(
    data: any
): data is InternalValidationError {
    return (
        "message" in data &&
        "details" in data &&
        typeof data.message === "string"
    );
}

export interface InternalValidationError {
    message: string;
    details?: string;
}

export interface UnknownError {
    message: string;
}

export function instanceOfUnknownError(data: any): data is UnknownError {
    return "message" in data && typeof data.message === "string";
}
